import {XlsxMetadataRestDto} from "@/api/pharma-cpc-import/models";

export class XlsxMetadataRestDtoModel implements XlsxMetadataRestDto {
    has_header: boolean;

    constructor(has_header: boolean) {
        this.has_header = has_header;
    }

    static createWithDefaults(): XlsxMetadataRestDtoModel {
        return new this(false);
    }
}
